function Header({ sumPoints, numQuestions, index, answer }) {
  return (
    <header className="header">
      <h2>Test Reducer App</h2>
      <img src="logo192.png" alt="react logo" />
    </header>
  );
}

export default Header;
